import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import SectionTitle from '../UI/SectionTitle';
import Calculator from './Calculator';

const Section = styled.section`
  padding: 80px 0;
  background-color: #f5f7ff;
  
  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Description = styled(motion.p)`
  max-width: 800px;
  text-align: center;
  margin-bottom: 40px;
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
`;

const CalculatorSection = () => {
  return (
    <Section id="calculator">
      <Container>
        <SectionTitle
          title="Калькулятор стоимости"
          subtitle="Рассчитайте оптовую цену для вашего заказа"
          centered
        />
        <Description
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Мы предлагаем выгодные условия для оптовых клиентов. Используйте наш калькулятор, 
          чтобы оценить стоимость вашего заказа. Чем больше объем заказа, тем ниже стоимость 
          каждого рулона.
        </Description>
        <Calculator />
      </Container>
    </Section>
  );
};

export default CalculatorSection; 